// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2JLiN","rightAdornment":"Header_rightAdornment___Qa9O"};